<template>
	<!-- 选品上架 -->
	<div class="leoshop leopages">
		<cube-page title="选品上架">
			<div slot="content" class="leocontent">
				<div class="gd-top" :style="'background-color:'+gcfg.BackgroundColor">
					<div class="searchbox">
						<div class="searchbox-item">
							<div class="lefticon">
								<van-icon name="search" />
							</div>
							<div class="righttitle" @click="goSearchPage">
								<span>点击搜索</span>
							</div>
						</div>
					</div>
				</div>
				<div class="leoshop-content">
					<div class="tzl">
						<van-notice-bar mode="closeable" left-icon="volume-o" :scrollable="false" color="#1989fa"
							background="#ecf9ff">
							<van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
								<van-swipe-item>明月直入，无心可猜。</van-swipe-item>
								<van-swipe-item>仙人抚我顶，结发受长生。</van-swipe-item>
								<van-swipe-item>今人不见古时月，今月曾经照古人。</van-swipe-item>
							</van-swipe>
						</van-notice-bar>
					</div>
					<van-swipe class="swipebox" :autoplay="3000" lazy-render>
						<van-swipe-item v-for="image in images" :key="image">
							<img :src="image" />
						</van-swipe-item>
					</van-swipe>
					<div class="listdata">
						<div class="listdata-title" :style="'background-color:'+gcfg.BackgroundColor">
							<span>分销推荐</span>
						</div>
						<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
							<van-cell v-for="value in 10" :key="value">
								<div class="cell-item" @click="goGoodsDetail(24)">
									<div class="leftimg">
										<img src="https://img01.yzcdn.cn/vant/apple-1.jpg">
									</div>
									<div class="right-content">
										<div class="title ells">
											九寨沟巴啦啦拉
										</div>
										<div class="remark">
											<p>撒旦发射点发射点</p>
											<p>撒旦发射点发射点</p>
											<p>撒旦发射点发射点</p>
											<p>撒旦发射点发射点</p>
										</div>
										<div class="price">
											<div class="yj">
												￥<span class="jg">155</span>
												<span> 已上架</span>
											</div>
											<div class="xj">
												<span class="an">
													<van-icon name="plus" />
												</span>
											</div>
										</div>
										<div class="xse">
											已售：<span>255522</span>份
										</div>
									</div>

								</div>
							</van-cell>
						</van-list>

					</div>
				</div>

			</div>
		</cube-page>
	</div>
</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import {
		Toast
	} from 'vant';
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				activeName: '',
				images: [
					'https://img.yzcdn.cn/vant/apple-1.jpg',
					'https://img.yzcdn.cn/vant/apple-2.jpg',
					'https://img.yzcdn.cn/vant/apple-3.jpg',
					'https://img.yzcdn.cn/vant/apple-4.jpg',
				],
				isSc: false,
				re_value: '',
				gcfg: [],
			}
		},
		methods: {
			goGoodsDetail(v) {
				this.$router.push({
					path: 'goodsdetail',
					query: {
						isSj: 'true',
						id: v,
						isQj:'true'
					}
				})
			},
			// 去查询界面
			goSearchPage() {
				this.$router.push({
					path: 'searchpagesj',
					query: {
						isSj: 'true'
					}
				})
			},
			// 去店铺信息详情页面
			goShopNamePage() {
				this.$router.push({
					path: 'shopxq'
				})
			},
			// 收藏按钮功能
			handelSc() {
				let that = this;
				let msg = "收藏成功";
				that.isSc = !that.isSc;
				if (!that.isSc) {
					msg = '取消收藏';
				}
				Toast({
					message: msg
				});
			},
			onLoad() {
				// 异步更新数据
				// setTimeout 仅做示例，真实场景中一般为 ajax 请求
				setTimeout(() => {
					for (let i = 0; i < 10; i++) {
						this.list.push(this.list.length + 1);
					}

					// 加载状态结束
					this.loading = false;

					// 数据全部加载完成
					if (this.list.length >= 20) {
						this.finished = true;
					}
				}, 1000);
			},
			onSearch() {

			}
		},
		created() {
			this.gcfg = this.$store.getters.getGcfg
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
		},
	}
</script>

<style lang="less" scoped="scoped">
	@import url("../../assets/css/base.less");
	@import url("../../assets/css/listboxless.less");
</style>
